import React, { useState, useEffect } from "react";
import Select from "react-select";
import {
  Button,
  ErrorMsg,
  DateWrapper,
} from "@onegovbugs/onegov-react-components";
import { useSelector, useDispatch } from "react-redux";
import styles from "./Associate.module.scss";
import {
  isAustralianPhoneNumberOrNull,
  isCompleted,
  isSelected,
  isValidEmail,
  isAFutureDate,
  isDateValidAnd18Yo,
  isDateValid,
  validate,
  objExistInArray,
  scrollToError,
} from "../../../utils/Validation";
import associateDetail from "redux/reducers/floraFauna/associateDetail";
import { withRouter } from "react-router-dom";
import { storeAssociateDetail } from "../../../redux/actions";
import { RedirectIfCaptchaNotSelected } from "../../../utils/Redirect";

const AssociateForm = (props) => {
  RedirectIfCaptchaNotSelected();
  const dispatch = useDispatch();

  let index = props.match.params.id;

  const associateDetail = useSelector((state) => state.associateDetail);
  const [associateList, setAssociateList] = useState(
    associateDetail && associateDetail.associateList
      ? associateDetail.associateList.map((on) => ({ ...on }))
      : []
  );
  const editAssociate =
    index && associateList && associateList.length > 0
      ? associateList[index]
      : undefined;

  const [title, setTitle] = useState(
    editAssociate ? editAssociate.title : null
  );
  const [firstName, setFirstName] = useState(
    editAssociate ? editAssociate.firstName : ""
  );
  const [middleName, setMiddleName] = useState(
    editAssociate ? editAssociate.middleName : ""
  );
  const [lastName, setLastName] = useState(
    editAssociate ? editAssociate.lastName : ""
  );
  const [dayOfBirth, setDayOfBirth] = useState(
    editAssociate ? editAssociate.dayOfBirth : ""
  );
  const [monthOfBirth, setMonthOfBirth] = useState(
    editAssociate ? editAssociate.monthOfBirth : ""
  );
  const [yearOfBirth, setYearOfBirth] = useState(
    editAssociate ? editAssociate.yearOfBirth : ""
  );
  const [isDOBRequired, setIsDOBRequired] = useState(true);
  const [isDOBValid, setIsDOBValid] = useState(true);
  const [dayTimePhoneNumber, setPhoneNumber] = useState(
    editAssociate ? editAssociate.dayTimePhoneNumber : ""
  );
  const [mobileNumber, setMobileNumber] = useState(
    editAssociate ? editAssociate.mobileNumber : ""
  );
  const [email, setEmail] = useState(editAssociate ? editAssociate.email : "");
  const [showErrors, setShowErrors] = useState(false);
  const [newAssociate, setNewAssociate] = useState("");
  const titleOptions = [
    {
      value: "mr",
      label: "Mr",
    },
    {
      value: "mrs",
      label: "Mrs",
    },
    {
      value: "miss",
      label: "Miss",
    },
    {
      value: "miss",
      label: "Ms",
    },
    {
      value: "sir",
      label: "Sir",
    },
    {
      value: "dr",
      label: "Dr",
    },
    {
      value: "prof",
      label: "Prof",
    },
    {
      value: "assocprof",
      label: "Assoc Prof",
    },
    {
      value: "rev",
      label: "Rev",
    },
    {
      value: "master",
      label: "Master",
    },
    {
      value: "father",
      label: "Father",
    },
    {
      value: "pastor",
      label: "Pastor",
    },
    {
      value: "sister",
      label: "Sister",
    },
  ];
  const [errors, setErrors] = useState({
    title: false,
    firstName: false,
    lastName: false,
    mobileNumber: false,
    dayTimePhoneNumber: false,
    email: true,
    dayOfBirth: false,
    monthOfBirth: false,
    yearOfBirth: false,
    associateAlreadyExists: false,
  });

  const validators = [
    {
      fieldName: "title",
      fieldValue: title,
      isValid: isSelected,
    },
    {
      fieldName: "firstName",
      fieldValue: firstName,
      isValid: isCompleted,
    },
    {
      fieldName: "lastName",
      fieldValue: lastName,
      isValid: isCompleted,
    },
    {
      fieldName: "mobileNumber",
      fieldValue: mobileNumber,
      isValid: (v) => isAustralianPhoneNumberOrNull(v),
    },
    {
      fieldName: "dayTimePhoneNumber",
      fieldValue: dayTimePhoneNumber,
      isValid: (v) => isAustralianPhoneNumberOrNull(v),
    },
    {
      fieldName: "isContactNumberFilled",
      fieldValue: dayTimePhoneNumber,
      isValid: (v) => isCompleted(v) || isCompleted(mobileNumber),
    },
    {
      fieldName: "isDateValidAnd18Yo",
      fieldValue: {
        day: dayOfBirth,
        month: monthOfBirth,
        year: yearOfBirth,
      },
      isValid: isDateValidAnd18Yo,
    },
    {
      fieldName: "isDOBRequired",
      fieldValue: {
        day: dayOfBirth,
        month: monthOfBirth,
        year: yearOfBirth,
      },
      isValid: (v) => dayOfBirth && monthOfBirth && yearOfBirth,
    },
    {
      fieldName: "isDOBValid",
      fieldValue: {
        day: dayOfBirth,
        month: monthOfBirth,
        year: yearOfBirth,
      },
      isValid: isDateValid,
    },
    {
      fieldName: "email",
      fieldValue: email,
      isValid: (v) => isCompleted(v),
    },
    {
      fieldName: "isValidEmail",
      fieldValue: email,
      isValid: (v) => (v !== "" ? isValidEmail(v) : true),
    },
    {
      fieldName: "associateAlreadyExists",
      fieldValue: associateList,
      isValid: (v) => {
        if (v && v.length === 0 || index !== undefined) return true;
        const newAssociate = {
          title: title ? title : "",
          lastName: lastName ? lastName : "",
          firstName: firstName ? firstName : "",
          middleName: middleName ? middleName : "",
          mobileNumber: mobileNumber ? mobileNumber : "",
          dayTimePhoneNumber: dayTimePhoneNumber ? dayTimePhoneNumber : "",
          email: email ? email : "",
          dayOfBirth: dayOfBirth,
          monthOfBirth: monthOfBirth,
          yearOfBirth: yearOfBirth,
        };

        return objExistInArray(v, newAssociate);

        //   const map = v.map((arr, i) => {
        //     var associateAlreadyExist = JSON.stringify(arr) === JSON.stringify(newAssociate);
        //     return (associateAlreadyExist)
        //   });

        // // What 'map' does is execute a function and collect all the returned values in a new array,
        // // so in this case the variable 'map' will contain an array with a boolean value.
        // const ret = map.reduce((acc, el) => acc = acc && el, true);
        // // I use reduce to accumulate the all the booleans into one.
        // return !ret;
        // I return the aggregated variable. If you don't return anything in this level you won't be returnin any value
        // inside the validation function and that's why you see undefined
      },
    },
  ];

  useEffect(() => {
    validate(validators, setErrors);
  }, [
    title,
    lastName,
    firstName,
    email,
    dayTimePhoneNumber,
    mobileNumber,
    dayOfBirth,
    monthOfBirth,
    yearOfBirth,
    newAssociate,
  ]);

  const storeData = () => {
    const associate = {
      hasAssociates: "yes",
      associateList: [
        ...associateList,
        {
          title: title ? title : "",
          lastName: lastName ? lastName : "",
          firstName: firstName ? firstName : "",
          middleName: middleName ? middleName : "",
          mobileNumber: mobileNumber ? mobileNumber : "",
          dayTimePhoneNumber: dayTimePhoneNumber ? dayTimePhoneNumber : "",
          email: email ? email : "",
          dayOfBirth: dayOfBirth,
          monthOfBirth: monthOfBirth,
          yearOfBirth: yearOfBirth,
        },
      ],
    };
    dispatch(storeAssociateDetail(associate));
  };

  const editData = (updatedAssociate) => {
    const qualificationRecord = {
      hasAssociate: "yes",
      associateList: updatedAssociate,
    };

    dispatch(storeAssociateDetail(qualificationRecord));
  };

  const saveAssociateData = () => {
    if (associateList && associateList.length > 0) {
      if (index) {
        let updatedAssociate = [...associateList];

        updatedAssociate[index] = {
          title: title ? title : "",
          lastName: lastName ? lastName : "",
          firstName: firstName ? firstName : "",
          middleName: middleName ? middleName : "",
          mobileNumber: mobileNumber ? mobileNumber : "",
          dayTimePhoneNumber: dayTimePhoneNumber ? dayTimePhoneNumber : "",
          email: email ? email : "",
          dayOfBirth: dayOfBirth,
          monthOfBirth: monthOfBirth,
          yearOfBirth: yearOfBirth,  
          
        };
        editData(updatedAssociate);
      } else {
        storeData();
      }
    } else {
      storeData();
    }
  };
  return (
    <div className={styles.mainCont}>
      <div className={"row"}>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor="title">Title</label>
          <Select
            id={"inputTitle"}
            value={title}
            onChange={setTitle}
            className={styles.select}
            options={titleOptions}
          />
          {errors.title && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"Title is required."}
            />
          ) : null}
        </div>

        <div className={"col-12 col-sm-6"}>
          <label htmlFor="lastName">Last Name</label>
          <input
            id="inputLastName"
            className={`${styles.inputBox}`}
            placeholder={"Last Name"}
            maxLength="50"
            value={lastName}
            onChange={(event) => {
              setLastName(event.target.value);
            }}
          />
          {errors.lastName && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"Last name is required."}
            />
          ) : null}
        </div>
      </div>
      <div className={"row"}>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor="firstName">First Name</label>
          <input
            id="inputFirstName"
            className={`${styles.inputBox}`}
            placeholder={"First Name"}
            maxLength="50"
            value={firstName}
            onChange={(event) => {
              setFirstName(event.target.value);
            }}
          />
          {errors.firstName && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"First Name is required."}
            />
          ) : null}
        </div>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor="middleName">Middle Name (Optional)</label>
          <input
            id="inputMiddleName"
            className={`${styles.inputBox}`}
            placeholder={"Middle Name"}
            maxLength="50"
            value={middleName}
            onChange={(event) => {
              setMiddleName(event.target.value);
            }}
          />
        </div>
      </div>
      <div className={"row"}>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor="dob">Date Of Birth</label>
          <DateWrapper
            setDayOfBirth={setDayOfBirth}
            setMonthOfBirth={setMonthOfBirth}
            setYearOfBirth={setYearOfBirth}
            onValidationChange={setIsDOBValid}
            onValidationRequired={setIsDOBRequired}
            day={dayOfBirth}
            month={monthOfBirth}
            year={yearOfBirth}
            autotab
          ></DateWrapper>
          {showErrors ? (
            errors.isDOBRequired ? (
              <ErrorMsg
                className={"ErrorMsg_error"}
                type={"error"}
                description={"Date Of Birth is required."}
              />
            ) : errors.isDOBValid ? (
              <ErrorMsg
                className={"ErrorMsg_error"}
                type={"error"}
                description={"Date Of Birth is invalid."}
              />
            ) : isAFutureDate(dayOfBirth, monthOfBirth, yearOfBirth) == true ? (
              <ErrorMsg
                className={"ErrorMsg_error"}
                type={"error"}
                description={"Date Of Birth cannot be in the future."}
              />
            ) : errors.isDateValidAnd18Yo ? (
              <ErrorMsg
                type={"error"}
                description={"Must be at least 18 years old."}
              />
            ) : null
          ) : null}
        </div>
        <div className={`col-12 col-sm-6 ${styles.marginTop}`}>
          <label htmlFor="email">Email Address</label>
          <input
            id="inputEmail"
            className={`${styles.inputBox}`}
            placeholder={"Email"}
            maxLength="100"
            value={email}
            onChange={(event) => {
              setEmail(event.target.value);
            }}
          />
          {errors.email && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"Email is required."}
            />
          ) : null}
          {errors.isValidEmail && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"Email address is invalid."}
            />
          ) : null}
        </div>
      </div>
      <div className={"row"}>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor="dayTimePhoneNumber">Daytime Telephone Number</label>
          <input
            id="inputPhoneNumber"
            className={`${styles.inputBox}`}
            placeholder={"Daytime Telephone Number"}
            value={dayTimePhoneNumber}
            onChange={(event) => {
              setPhoneNumber(event.target.value);
            }}
          />
          {dayTimePhoneNumber !== null &&
          dayTimePhoneNumber !== "" &&
          errors.dayTimePhoneNumber &&
          showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"Day time phone number is invalid."}
            />
          ) : null}
          {errors.isContactNumberFilled && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={
                "Either day time phone or mobile number is mandatory."
              }
            />
          ) : null}
        </div>
        <div className={"col-12 col-sm-6"}>
          <label htmlFor="mobileNumber">Mobile number</label>
          <input
            id="inputMobileNumber"
            className={`${styles.inputBox}`}
            placeholder={"Mobile number"}
            maxLength="20"
            value={mobileNumber}
            onChange={(event) => {
              setMobileNumber(event.target.value);
            }}
          />
          {mobileNumber !== null &&
          mobileNumber !== "" &&
          errors.mobileNumber &&
          showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={"Mobile number is invalid."}
            />
          ) : null}
          {errors.isContactNumberFilled && showErrors ? (
            <ErrorMsg
              className={"ErrorMsg_error"}
              type={"error"}
              description={
                "Either day time phone or mobile number is mandatory."
              }
            />
          ) : null}
        </div>
      </div>
      {errors.associateAlreadyExists && showErrors ? (
        <ErrorMsg
          className={"ErrorMsg_error"}
          type={"error"}
          description={"Associate detail already exists."}
        />
      ) : null}
      <div className={"row " + styles.buttonCont}>
        <div className={"col-12"}>
          <Button
            onClick={() => {
              if (validate(validators, setErrors)) {
                saveAssociateData();
                props.history.push(`/flora-fauna/associate`);
              } else {
                setShowErrors(true);
                scrollToError();
              }
            }}
          >
            Save
          </Button>
          <Button
            secondary
            onClick={() => {
              setShowErrors(false);
              props.history.push(`/flora-fauna/associate`);
            }}
          >
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};

export default  withRouter((props) => <AssociateForm {...props} />);
